module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar-search",
    attrs: {
      "id": "page__additional-services-prices-search"
    }
  }, [_c('z-select', {
    attrs: {
      "light": "",
      "id": "filter_service_id",
      "name": "filter_service_id"
    },
    model: {
      value: (_vm.filter.service_id),
      callback: function($$v) {
        _vm.$set(_vm.filter, "service_id", $$v)
      },
      expression: "filter.service_id"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(" Услуга (любая) ")]), _vm._v(" "), _vm._l((_vm.services), function(item) {
    return _c('option', {
      key: ("filter-add-services-prices-item-" + (item.id)),
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "rounded": "",
      "danger-light": "",
      "disabled": !_vm.hasFilter
    },
    on: {
      "click": _vm.onReset
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6de22450","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/toolbars/AdditionalServicesPricesToolbar.vue
// module id = 1181
// module chunks = 0